export var ReceiptStatus;
(function (ReceiptStatus) {
    ReceiptStatus["Created"] = "Created";
    ReceiptStatus["Canceled"] = "Canceled";
    ReceiptStatus["Pending"] = "Pending";
})(ReceiptStatus || (ReceiptStatus = {}));
